const IDLE = {
    action: 'idle'
};
export const planIntercomSession = (param)=>{
    let { isRealUser, enabledForRoute, featureFlagsLoaded, useJwtIdentity, lastMode } = param;
    if (!isRealUser || !enabledForRoute) {
        return lastMode === 'shutdown' ? IDLE : {
            action: 'shutdown'
        };
    }
    if (!featureFlagsLoaded) {
        return IDLE;
    }
    const mode = useJwtIdentity ? 'jwt' : 'legacy';
    if (mode === 'legacy' && lastMode === 'legacy') {
        return IDLE;
    }
    return {
        action: 'start',
        mode,
        shutdownFirst: lastMode === 'jwt' || lastMode === 'legacy'
    };
};
